module.exports = __webpack_public_path__ + "static/media/iconDownArrow.aa10c523.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconDownArrow.svg
// module id = 865
// module chunks = 0